import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs';

import { PortalLeadNode } from '@app/services/api/api.types';
import { GoogleFlightOption } from '@app/services/google-flights/google-flights.types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleFlightsService {
  httpClient = inject(HttpClient);

  getFlight(lead: PortalLeadNode) {
    const params = prepareQueryParams(lead);

    return this.httpClient
      .get<{ results: GoogleFlightOption[] }>(googleFlightsUrl, { params })
      .pipe(map((data) => data?.results?.[0] as GoogleFlightOption));
  }
}

const prepareQueryParams = (lead: PortalLeadNode) => {
  let params = new HttpParams();

  const data: { [key: string]: string } = {
    departure_id: lead.firstTrip?.departureAirport.locationCode || '',
    arrival_id: lead.firstTrip?.arrivalAirport.locationCode || '',
    outbound_date: lead.firstTrip?.departureAt || '',
    return_date: lead.roundTripDepartureAt || '',
    limit: '1',
  };

  const travel_class = getTravelClass(lead);

  if (travel_class) {
    Object.assign(data, { travel_class });
  }

  for (const key in data) {
    const value = data[key];

    if (value) {
      params = params.set(key, value);
    }
  }

  return params;
};

const getTravelClass = (lead: PortalLeadNode) => {
  const travelClassesMap: { [key: string]: string } = {
    ECONOMY: '1',
    PREMIUM_ECONOMY: '2',
    BUSINESS: '3',
    FIRST: '4',
  };

  const serviceClass = lead.firstTrip?.serviceClass;

  if (serviceClass) {
    return travelClassesMap[serviceClass];
  }

  return '';
};

const googleFlightsUrl = environment.GOOGLE_FLIGHTS_URL as string;
